import { render, staticRenderFns } from "./vueAudio.vue?vue&type=template&id=18806531&scoped=true"
import script from "./vueAudio.vue?vue&type=script&lang=js"
export * from "./vueAudio.vue?vue&type=script&lang=js"
import style0 from "./vueAudio.vue?vue&type=style&index=0&id=18806531&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18806531",
  null
  
)

export default component.exports